(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["takt-product-tools"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('takt-product-tools')){
    customElements.define('takt-product-tools',class extends HTMLElement{
      async connectedCallback(){
        this.root=this.closest('product-info');
        this.events=new AbortController();
        this.map=JSON.parse(this.querySelector('[data-takt-gallery-map]').textContent);
        this.mediaOrder=JSON.parse(this.querySelector('[data-takt-media-order]').textContent);
        this.sticky=this.querySelector('[data-takt-sticky]');
        this.primary=this.root.querySelector('.product-form__submit');
        this.stickyButton=this.querySelector('[data-takt-sticky-submit]');
        const options={signal:this.events.signal};
        this.stickyButton.addEventListener('click',()=>{
          if(!this.primary.disabled&&this.primary.getAttribute('aria-disabled')!=='true')this.primary.click();
        },options);
        this.primaryObserver=new MutationObserver(()=>this.syncBuy());
        this.primaryObserver.observe(this.primary,{attributes:true,childList:true,subtree:true});
        this.intersection=new IntersectionObserver(()=>this.updateSticky(),{threshold:[0,1]});
        this.intersection.observe(this.primary);
        const updatePosition=()=>{
          if(this.scrollFrame)return;
          this.scrollFrame=requestAnimationFrame(()=>{this.scrollFrame=null;this.updateSticky();});
        };
        window.addEventListener('scroll',updatePosition,{...options,passive:true});
        this.viewportWidth=window.innerWidth;
        window.addEventListener('resize',()=>{
          updatePosition();
          if(this.viewportWidth===window.innerWidth)return;
          this.viewportWidth=window.innerWidth;
          this.resetGalleryGesture();
          clearTimeout(this.resizeTimer);
          this.resizeTimer=setTimeout(()=>this.applyMedia(),160);
        },options);
        this.updateSticky();
        this.variantUnsubscribe=subscribe(PUB_SUB_EVENTS.variantChange,({data})=>{
          if(data.sectionId!==this.dataset.section)return;
          if(data.variant){this.dataset.variant=String(data.variant.id);this.applyMedia();this.syncBuy();}
        });
        this.errorUnsubscribe=subscribe(PUB_SUB_EVENTS.cartError,()=>{
          this.root.querySelector('product-form').scrollIntoView({behavior:'smooth',block:'center'});
        });
        this.syncBuy();
        await customElements.whenDefined('media-gallery');
        if(!this.isConnected)return;
        this.gallery=this.root.querySelector('media-gallery');
        this.viewer=this.gallery.querySelector('[id^=GalleryViewer]');
        this.viewerList=this.viewer.querySelector('ul');
        this.thumbList=this.gallery.querySelector('[id^=Slider-Thumbnails]');
        this.gallery.append(this.querySelector('[data-takt-controls]').content.cloneNode(true));
        this.gallery.querySelectorAll('[data-takt-step]').forEach(button=>button.addEventListener('click',()=>this.go(Number(button.dataset.taktStep)),options));
        this.viewerList.tabIndex=0;
        const startGesture=(x,y)=>{
          this.resetGalleryGesture();
          this.gestureStart={x,y};
        };
        const moveGesture=(x,y)=>{
          if(!this.gestureStart)return;
          const dx=Math.abs(x-this.gestureStart.x),dy=Math.abs(y-this.gestureStart.y);
          if(dx>10&&dx>dy){this.userGalleryScrolling=true;this.scheduleMediaSelection();}
        };
        this.viewerList.addEventListener('pointerdown',event=>startGesture(event.clientX,event.clientY),options);
        this.viewerList.addEventListener('pointermove',event=>moveGesture(event.clientX,event.clientY),options);
        this.viewerList.addEventListener('touchstart',event=>{const touch=event.touches[0];if(touch)startGesture(touch.clientX,touch.clientY);},{...options,passive:true});
        this.viewerList.addEventListener('touchmove',event=>{const touch=event.touches[0];if(touch)moveGesture(touch.clientX,touch.clientY);},{...options,passive:true});
        this.viewerList.addEventListener('pointerup',()=>{this.gestureStart=null;if(!this.userGalleryScrolling)this.resetGalleryGesture();},options);
        this.viewerList.addEventListener('touchend',()=>{this.gestureStart=null;if(!this.userGalleryScrolling)this.resetGalleryGesture();},{...options,passive:true});
        this.viewerList.addEventListener('click',()=>this.resetGalleryGesture(),options);
        this.viewerList.addEventListener('wheel',event=>{if(Math.abs(event.deltaX)>Math.abs(event.deltaY)){this.userGalleryScrolling=true;this.scheduleMediaSelection();}},{...options,passive:true});
        this.viewerList.addEventListener('scroll',()=>{if(this.userGalleryScrolling)this.scheduleMediaSelection();},{...options,passive:true});
        this.root.addEventListener('change',event=>{
          if(event.target.closest('variant-selects')){this.userGalleryScrolling=false;clearTimeout(this.mediaChangeTimer);}
        },options);
        this.viewerList.addEventListener('keydown',event=>{
          if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();this.go(event.key==='ArrowRight'?1:-1);}
        },options);
        this.viewer.addEventListener('slideChanged',event=>{
          if(event.detail?.currentElement){
            const index=this.ids?.indexOf(event.detail.currentElement.dataset.mediaId);
            if(index>=0){
              this.index=index;this.syncCount();
              if(this.userGalleryScrolling)this.scheduleMediaSelection();
            }
          }
        },options);
        this.thumbList?.addEventListener('click',event=>{
          const target=event.target.closest('[data-target]');
          if(target){this.userGalleryScrolling=false;clearTimeout(this.mediaChangeTimer);this.index=this.ids.indexOf(target.dataset.target);this.syncCount();this.selectMediaVariant(target.dataset.target);}
        },options);
        this.applyMedia();
      }
      resetGalleryGesture(){
        this.userGalleryScrolling=false;
        this.gestureStart=null;
        clearTimeout(this.mediaChangeTimer);
      }
      scheduleMediaSelection(){
        clearTimeout(this.mediaChangeTimer);
        this.mediaChangeTimer=setTimeout(()=>{
          if(!this.userGalleryScrolling)return;
          const left=this.viewerList.getBoundingClientRect().left;
          const media=[...this.viewerList.querySelectorAll('li[data-media-id]')].reduce((nearest,item)=>!nearest||Math.abs(item.getBoundingClientRect().left-left)<Math.abs(nearest.getBoundingClientRect().left-left)?item:nearest,null);
          this.resetGalleryGesture();
          if(media)this.selectMediaVariant(media.dataset.mediaId);
        },240);
      }
      applyMedia(){
        if(!this.gallery)return;
        this.resetGalleryGesture();
        const state=this.map[this.dataset.variant];
        if(!state)return;
        this.ids=this.mediaOrder.map(id=>this.dataset.section+'-'+id);
        this.viewerList.querySelectorAll('li[data-media-id]').forEach(item=>{item.hidden=false;});
        this.thumbList?.querySelectorAll('[data-target]').forEach(item=>{item.hidden=false;});
        [...this.ids].reverse().forEach(id=>{
          const media=this.viewerList.querySelector('[data-media-id="'+id+'"]');
          const thumb=this.thumbList?.querySelector('[data-target="'+id+'"]');
          if(media)this.viewerList.prepend(media);
          if(thumb)this.thumbList.prepend(thumb);
        });
        this.ids=this.ids.filter(id=>this.viewerList.querySelector('[data-media-id="'+id+'"]'));
        const modal=document.getElementById('ProductModal-'+this.dataset.section);
        modal?.classList.add('takt-product-modal');
        modal?.querySelectorAll('[data-media-id]').forEach(media=>{
          media.hidden=false;
        });
        const selectedIndex=Math.max(0,this.ids.indexOf(this.dataset.section+'-'+state.featured));
        this.viewer.resetPages?.();
        this.gallery.elements.thumbnails?.resetPages?.();
        this.index=selectedIndex;
        if(this.ids.length)this.gallery.setActiveMedia(this.ids[selectedIndex],false);
        if(window.innerWidth<750){
          this.root.querySelectorAll('.takt-color-options').forEach(row=>{
            const selected=row.querySelector('input:checked+label');
            if(!selected)return;
            const box=selected.getBoundingClientRect(),frame=row.getBoundingClientRect();
            if(box.left<frame.left)row.scrollLeft-=frame.left-box.left+4;
            else if(box.right>frame.right)row.scrollLeft+=box.right-frame.right+4;
          });
        }
        this.root.dataset.taktReady='true';
        this.syncCount();
      }
      go(step){
        this.userGalleryScrolling=false;
        clearTimeout(this.mediaChangeTimer);
        const index=Math.max(0,Math.min(this.ids.length-1,this.index+step));
        this.index=index;
        this.gallery.setActiveMedia(this.ids[index],false);
        this.syncCount();
        this.selectMediaVariant(this.ids[index]);
      }
      selectMediaVariant(mediaId){
        const rawId=mediaId?.slice(this.dataset.section.length+1);
        if(!rawId)return;
        const current=this.map[this.dataset.variant];
        if(current?.linked_media===rawId)return;
        const candidates=Object.entries(this.map).filter(([,variant])=>variant.linked_media===rawId);
        if(!candidates.length)return;
        const candidate=candidates.find(([,variant])=>variant.options.slice(1).every((value,index)=>value===current?.options[index+1]))||candidates[0];
        const picker=[...this.root.querySelectorAll('variant-selects')].find(el=>getComputedStyle(el).display!=='none');
        if(!picker)return;
        const groups=[...picker.querySelectorAll('fieldset,select')];
        const inputs=candidate[1].options.map((value,index)=>{
          const group=groups[index];
          if(group?.tagName==='SELECT')return [...group.options].find(option=>option.value===value);
          return group&&[...group.querySelectorAll('input[type=radio]')].find(input=>input.value===value);
        });
        if(inputs.some(input=>!input))return;
        let changed;
        inputs.forEach(input=>{
          if(input.tagName==='OPTION'){
            const select=input.parentElement;
            if(select.value!==input.value){select.value=input.value;changed=select;}
          }else if(!input.checked){input.checked=true;changed=input;}
        });
        changed?.dispatchEvent(new Event('change',{bubbles:true}));
      }
      syncCount(){
        if(!this.gallery||!this.ids)return;
        this.gallery.querySelector('.takt-gallery-controls').hidden=this.ids.length<2;
        this.gallery.querySelector('[data-takt-count]').textContent=(this.index+1)+' / '+this.ids.length;
        this.gallery.querySelector('[data-takt-step="-1"]').disabled=this.index===0;
        this.gallery.querySelector('[data-takt-step="1"]').disabled=this.index===this.ids.length-1;
        const thumb=this.thumbList?.querySelector('[data-target="'+this.ids[this.index]+'"]');
        if(thumb&&matchMedia('(min-width:750px)').matches){
          const item=thumb.getBoundingClientRect(),list=this.thumbList.getBoundingClientRect();
          if(item.top<list.top)this.thumbList.scrollTop-=list.top-item.top;
          else if(item.bottom>list.bottom)this.thumbList.scrollTop+=item.bottom-list.bottom;
        }
      }
      syncBuy(){
        const state=this.map[this.dataset.variant];
        if(state){
          this.querySelector('[data-takt-sticky-price]').textContent=state.price;
          this.querySelector('[data-takt-sticky-color]').textContent=state.title;
        }
        this.stickyButton.disabled=this.primary.disabled||this.primary.getAttribute('aria-disabled')==='true';
        this.stickyButton.textContent=this.primary.querySelector('span')?.textContent.trim()||this.primary.textContent.trim();
      }
      updateSticky(){
        this.sticky.hidden=window.innerWidth>=750||this.primary.getBoundingClientRect().bottom>=0;
      }
      disconnectedCallback(){
        clearTimeout(this.mediaChangeTimer);
        clearTimeout(this.resizeTimer);
        this.events?.abort();
        this.primaryObserver?.disconnect();
        this.intersection?.disconnect();
        if(this.scrollFrame)cancelAnimationFrame(this.scrollFrame);
        this.variantUnsubscribe?.();
        this.errorUnsubscribe?.();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
